<template>
    <div class="checkout-cart mb-4">
        <b-row>
            <b-col class="col-md-12">
                <div class="confirmation d-flex flex-column align-items-center justify-content-center mb-4" 
                >
                    <!-- <p><img src="../images/no-data-found.png"></p> -->
                    <div>
                        <h3 class="mb-4 text-success">{{$t('Your order was completed successfully')}}</h3>
                        <p style="text-align:center">{{$t('Your order number is')}} : <strong>{{ getOrderNumber() }}</strong></p>
                        <p style="text-align:center">{{$t('An email receipt including the details about your order has been sent to the email address provided')}}.</p>
                        <p style="text-align:center">{{$t('You can contact us at asiakaspalvelu@renkatalle.fi OR call on (04) 0552 9803 for any corrections')}}.</p>
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: "TabOrderConfirm",
    props: {
        
    },
    data() {
        return {

        }
    },
    mounted() {
        
    },
    computed: {
        ...mapGetters('order', ['paymentConfirmation'])
    },
    created() {
        this.clearCartProducts();
    },
    methods: {
        ...mapActions('cart', ['clearCartProducts']),
        getOrderNumber() {
            let orderNo = ""
            if(this.paymentConfirmation && this.paymentConfirmation.order_number) {
                orderNo = this.paymentConfirmation.order_number
            }
            if(orderNo=="") {
                this.$router.push({
                    path:'/cart',
                    params:{}
                });
            }
            return orderNo
        }
        // setOrderConfirm() {
        //     if(this.$route.query) {
        //         let formData = new FormData();
        //         formData.append('order_number', this.$route.query.ORDER_NUMBER);
        //         formData.append('timestamp', this.$route.query.TIMESTAMP);
        //         formData.append('paid', this.$route.query.PAID);
        //         formData.append('method', this.$route.query.METHOD);
        //         formData.append('return_auth_code', this.$route.query.RETURN_AUTHCODE);
        //         this.confirmPaymentWithPaytrail(formData)
        //     }
        // }
    },
}
</script>